import { __rest, __assign } from 'tslib';
import React from 'react';
import { useIsDesktop } from '../../mq/esm';
export { Caption as SystemMessageCaption } from './components/caption/Component.js';
export { Controls as SystemMessageControls } from './components/controls/Component.js';
export { Graphic as SystemMessageGraphic } from './components/graphic/Component.js';
export { Subtitle as SystemMessageSubtitle } from './components/subtitle/Component.js';
export { Title as SystemMessageTitle } from './components/title/Component.js';
import { SystemMessage } from './Component.js';
import { createCompound } from './utils.js';
import 'classnames';
import '../../shared/esm';
import './Context.js';

var SystemMessageResponsiveComponent = function (_a) {
    var breakpoint = _a.breakpoint, client = _a.client, _b = _a.defaultMatchMediaValue, defaultMatchMediaValue = _b === void 0 ? client === undefined ? undefined : client === 'desktop' : _b, children = _a.children, restProps = __rest(_a, ["breakpoint", "client", "defaultMatchMediaValue", "children"]);
    var isDesktop = useIsDesktop(breakpoint, defaultMatchMediaValue);
    return (React.createElement(SystemMessage, __assign({}, restProps, { view: isDesktop ? 'desktop' : 'mobile' }), children));
};
var SystemMessageResponsive = createCompound(SystemMessageResponsiveComponent);

export { SystemMessageResponsiveComponent as SystemMessageComponent, SystemMessageResponsive };
